import axios from 'axios';

const scrBaseURL='http://localhost:8083/api/';
const axiosOrg = axios.create({
  baseURL: scrBaseURL,
  timeout: 10000,
});

class ScrService{
    static baseURL(){
        return scrBaseURL;
    }
    static async insertTest(test) {
        test.id = null;
        return axiosOrg.post('tests', test).then(res => res.data);      
    }
    static async updateTestInfo(test) {
      return axiosOrg.post('tests/' + test.id, test).then(res => res.data);
    }
    static async copyTest(test) {
      return axiosOrg.post('tests/' + test.id+'/copy', test).then(res => res.data);
    }
    static async getScoreDef(testId){
      return axiosOrg.get('tests/'+testId+'/scoreDef').then(res => res.data);
    }
    static async insertScore(testId,score) {
      score.id = null;
      score.testId = testId;
      return axiosOrg.post('tests/'+testId+'/scores', score).then(res => res.data);
    }
    static async deleteScores(testId,ids)
    {
      var idList = { ids: ids };
      return axiosOrg.post('tests/'+testId+'/scores/delete', idList, { headers: { "Content-Type": "application/json" } }).then(res => res.data);      
    }
    static async updateScore(testId,score)
    {
      return axiosOrg.post('tests/'+testId+'/scores/'+score.id, score).then(res => res.data); 
    }
    static async moveScore(testId,scoreId,dir)
    {
      return axiosOrg.post('tests/'+testId+'/scores/'+scoreId+'/move?dir='+dir).then(res => res.data); 
    }
    static async updateTestScoreDef(testId,scoreDef) {
      return axiosOrg.post('tests/' + testId+"/updateScoreDef", scoreDef).then(res => res.data);
    }
    static async getTestScores(testId){
      return axiosOrg.get('tests/' + testId + '/scores').then(res => res.data);
    }

    static async insertSect(testId,sect) {
      sect.id = null;
      return axiosOrg.post('tests/' + testId + '/sects', sect).then(res => res.data);
    }
    static async deleteSect(testId,sectId) {
      return axiosOrg.delete('tests/' + testId + '/sects/' + sectId).then(res => res.data);
    }
    static async sortTest(testId,sortTest) {
      return axiosOrg.post('tests/' + testId + '/sort', sortTest).then(res => res.data);
    }

    static async getSects(testId) {
      return axiosOrg.get('tests/' + testId + '/sects').then(res => res.data);
    }
    static async insertItems(testId,sectId,item)
    {
      item.id=0;
      return axiosOrg.post('tests/' + testId + '/sects/' + sectId + '/items', item).then(res => res.data);
    }
    static async addQuestionsToTest(testId,sectId,items)
    {
      var idList = { ids: items };

      return axiosOrg.post('tests/' + testId + '/sects/' + sectId + '/addQuestions', idList).then(res => res.data);      
    }

    static async deleteItems(testId,sectId,ids)
    {
      var idList = { ids: ids };
      return axiosOrg.post('tests/'+testId+'/sects/'+sectId+'/items/delete', idList, { headers: { "Content-Type": "application/json" } }).then(res => res.data);
    }
    static async setItemsCat(testId,sectId,ids,catId)
    {
      var idList = { ids: ids };
      return axiosOrg.post('tests/'+testId+'/sects/'+sectId+'/items/setCat?catId='+catId, idList, { headers: { "Content-Type": "application/json" } }).then(res => res.data);
    }
    static async updateItem(testId,item)
    {
      return axiosOrg.post('tests/' + testId + '/items/' + item.id, item).then(res => res.data);
    }
    static async updateItems(testId,itemList)
    {
      return axiosOrg.post('tests/' + testId + '/items', itemList).then(res => res.data);
    }
    static async updateAnswerKey(testId,answerKey)
    {
      return axiosOrg.post('tests/' + testId + '/answerKey', answerKey).then(res => res.data);
    }

    static async moveItem(testId,sectId,booklet,itemId,direction)
    {
      return axiosOrg.post('tests/'+testId+'/sects/'+sectId+'/items/'+itemId+'/move?booklet='+booklet+'&direction='+direction, { headers: { "Content-Type": "application/json" } }).then(res => res.data);
    }
    static async getItems(testId,sectId)
    {
      return axiosOrg.get('tests/' + testId + '/sects/'+ sectId + '/items').then(res => res.data);      
    }
    static async getBookletItems(testId)
    {
      return axiosOrg.get('tests/' + testId + '/bookletItems').then(res => res.data);      
    }
    static async getTestsByOrg(orgId,query)
    {
      if(query == undefined)
        return [];
      var url=orgId!=undefined?"tests?orgId="+orgId:"tests?orgId=0";
      if(query.term!=undefined && query.term!=0) url=url+"&termId="+query.term;
      if(query.crs!=undefined && query.crs!=0) url=url+"&crsId="+query.crs;
      if(query.appType!=undefined && query.appType!='ALL') url=url+"&appType="+query.appType;
      if(query.testType!=undefined && query.testType!='ALL') url=url+"&testType="+query.testType;
      if(query.examType!=undefined && query.examType!='ALL') url=url+"&examType="+query.examType;
      if(query.status!=undefined && query.status!='ALL') url=url+"&status="+query.status;
      if(query.year!=undefined && query.year!='ALL') url=url+"&testYear="+query.year;
      if(query.key!=undefined) url=url+"&key="+query.key;
      return axiosOrg.get(url).then(res=>res.data);      
    }    
    static async getTestsByCls(clsId,query)
    {
      var url="tests?clsId="+clsId;
      if(query.appType!=undefined && query.appType!='ALL') url=url+"&appType="+query.appType;
      if(query.testType!=undefined && query.testType!='ALL') url=url+"&testType="+query.testType;
      if(query.examType!=undefined && query.examType!='ALL') url=url+"&examType="+query.examType;
      if(query.status!=undefined && query.status!='ALL') url=url+"&status="+query.status;
      if(query.year!=undefined && query.year!='ALL') url=url+"&testYear="+query.year;

      return axiosOrg.get(url).then(res=>res.data);
      
    }    

    static async searchTestYears(orgId)
    {
      return axiosOrg.get('searchTestYears?orgId='+orgId).then(res => res.data);
    }
    static async getTestStds(testId)
    {
      return axiosOrg.get('tests/' + testId + '/students').then(res => res.data);
      
    }
    static async deleteTestStds(testId,ids)
    {
      var idList = { ids: ids };
      return axiosOrg.post('tests/'+testId+'/students/delete', idList, { headers: { "Content-Type": "application/json" } }).then(res => res.data);
    }    
    static async getTest(testId)
    {
      return axiosOrg.get('tests/' + testId).then(res => res.data);
    }
    static async uploadTestStdData(testId,loadData,progressHandler)
    {
      var formData = new FormData();
      formData.append("fileName",loadData.file.name);
      formData.append("file",loadData.file);
      formData.append("fileType",loadData.file.type);
      formData.append("respFileType",loadData.respFileType);
      formData.append("separator",loadData.separator);
      formData.append("updateExisting",loadData.updateExisting);
      formData.append("skipFirstRow",loadData.skipFirstRow);
      formData.append("pkey",loadData.pkey);
      formData.append("school",loadData.school);
  
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: progressHandler
      }
      return axiosOrg.post('tests/'+testId+'/teststds/load',formData,config).then(res => res.data);
    }
    static async uploadTestStdDataColMap(testId,procId,colMap)
    {
      return axiosOrg.post('tests/'+testId+'/teststds/load/'+procId+'/colmap',colMap).then(res => res.data);
    }
    static async uploadTestStdDataCommit(testId,procId,colMap)
    {
      return axiosOrg.post('tests/'+testId+'/teststds/load/'+procId+'/commit',colMap).then(res => res.data);
    }
    static async uploadTestStdDataPatch(testId,procId,rowId,rowData)
    {
      return axiosOrg.post('tests/'+testId+'/teststds/load/'+procId+'/patch?rowId='+rowId,rowData).then(res => res.data);
    }
    static async getTestStdLoadData(orgId,procId)
    {
      return axiosOrg.get('tests/'+orgId+'/teststds/load/'+procId).then(res => res.data);
    }
    static async getProc(id)
    {
      return axiosOrg.get('procs/'+id).then(res => res.data);
    }    
    static async getProfiles(procType)
    {
      return axiosOrg.get('profiles?procType=' + procType).then(res => res.data);
      
    }
    static async getProfile(id)
    {
      return axiosOrg.get('profile/' + id).then(res => res.data);
      
    }
    static async createLoadProfile(name,tag,columns)
    {
      return axiosOrg.post('profiles',{procType:'LOADRESP',name:name,tag:tag,columns:columns}).then(res => res.data);
      
    }
    static async updateLoadProfile(id,columns)
    {
      return axiosOrg.post('profiles/'+id,{columns:columns}).then(res => res.data);
      
    }
    static async registerStudentsToExam(id,studentIds)
    {
      var idList = { ids: studentIds };
      return axiosOrg.post('tests/'+id+'/students',idList).then(res => res.data);
      
    }
    static async getScoreMethods()
    {
      return axiosOrg.get('scoreMethods').then(res => res.data);
      
    }
    static async getScoreTemplate(name)
    {
      return axiosOrg.get('scoreTemplate/' + name).then(res => res.data);
      
    }
    static async getNoteMaps()
    {
      return axiosOrg.get('notemaps').then(res => res.data);
      
    }
    static async getNoteMap(id)
    {
      return axiosOrg.get('notemap/'+id).then(res => res.data);
      
    }
    static async deleteNoteMap(id)
    {
      return axiosOrg.delete('notemap/'+id).then(res => res.data);
      
    }
    static async deleteNoteMaps(ids)
    {
      var idList = { ids: ids };      
      return axiosOrg.post('notemaps',idList).then(res => res.data);
      
    }    
    static async updateNoteMap(noteMap)
    {
      return axiosOrg.post('notemap/'+noteMap.id,noteMap).then(res => res.data);
      
    }
    static async createNoteMap(noteMap)
    {
      return axiosOrg.post('notemaps',noteMap).then(res => res.data);
      
    }
    static async runScorer(testId)
    {
      return axiosOrg.post('tests/'+testId+"/score").then(res => res.data);
      
    }
    static async stopProc(procId)
    {
      return axiosOrg.post('procs/'+procId+"/stop").then(res => res.data);
      
    }
    static async getActiveScoreProc(testId)
    {
      return axiosOrg.get('tests/'+testId+'/scoreProc').then(res => res.data);
      
    }
    static async getScoreStats(testId,subjType)
    {
      return axiosOrg.get('tests/'+testId+'/scoreStats?subjType='+subjType).then(res => res.data);
      
    }
    static async getClsCums(testId,clsId,catType)
    {
      return axiosOrg.get('tests/'+testId+'/clss/'+clsId+'/cums?catType='+catType).then(res => res.data);
      
    }
    static async getClsStats(testId,clsId)
    {
      return axiosOrg.get('tests/'+testId+'/clss/'+clsId+'/stats').then(res => res.data);      
    }
    static async getTestStdResps(testId,stdId)
    {
      return axiosOrg.get('tests/'+testId+'/testStds/'+stdId+'/resps').then(res => res.data);
      
    }
    static async updateTestStdResps(testId,stdId,resps)
    {
      return axiosOrg.post('tests/'+testId+'/testStds/'+stdId+'/resps',resps).then(res => res.data);
      
    }
    static async updateTestStdStatus(testId,stdId,status)
    {
      var config = {
        headers: {
            'Content-Type': 'text/plain'
        },
       responseType: 'json'
      };
      return axiosOrg.post('tests/'+testId+'/testStds/'+stdId+'/status',status,config).then(res => res.data);
      
    }
    static async updateTestStdBooklet(testId,stdId,booklet)
    {
      var config = {
        headers: {
            'Content-Type': 'text/plain'
        },
       responseType: 'json'
      };
      return axiosOrg.post('tests/'+testId+'/testStds/'+stdId+'/booklet',booklet,config).then(res => res.data);      
    }
    static async getTestStdCums(testId,stdId)
    {
      return axiosOrg.get('tests/'+testId+'/testStds/'+stdId+'/stats?catType=SECT').then(res => res.data);      
    }
    static async getTestStd(testId,stdId)
    {
      return axiosOrg.get('tests/'+testId+'/testStds/'+stdId).then(res => res.data);      
    }
    static async createReport(reportLink,report) {
      return axiosOrg.post(reportLink, report).then(res => res.data);
    }  
    static async createReportDOC(procId,format,detail,settings){
      return axiosOrg.post('reports/'+procId+'/createdoc'+'?format='+format+(detail>0?'&detail='+detail:''),settings).then(res => res.data);
    }
    static async reportExportPDF(procId){
      return axiosOrg.get('reports/'+procId+'/pdf',{timeout:100000,responseType:'blob'});
    }
    static async reportExportDOC(procId){
      return axiosOrg.get('reports/'+procId+'/doc',{timeout:100000,responseType:'blob'});
    }
    static async getProcDatDoc(procId){
      return axiosOrg.get('procs/'+procId+'/doc',{timeout:100000,responseType:'blob'});
    }
    static async getProcDatPdf(procId){
      return axiosOrg.get('procs/'+procId+'/pdf',{timeout:100000,responseType:'blob'});
    }
 }

export default ScrService;